import React, { useLayoutEffect, useRef, useState } from "react";
import type { AotdDay } from "../printsApi";
import type { PrintEdition, PrintFormat } from "../printProducts";
import { PrintFaceThumb } from "../showcase/PrintFaceThumb";

// A print face centred on a square of paper-grey, sized to the square: what a tile or a gallery
// slide shows before any mockup photo. The faces draw at a fixed px width, so measure first.

export const FitFace: React.FC<{ day: AotdDay; format: PrintFormat; edition: PrintEdition; fill?: number }> = ({
  day,
  format,
  edition,
  fill = 0.78,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [side, setSide] = useState(0);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    setSide(el.clientWidth);
    const ro = new ResizeObserver(([entry]) => setSide(entry.contentRect.width));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  // a card is taller than wide: fit its height, a sheet fits its width
  const width = format === "trading-card" ? (side * (fill + 0.06) * 63) / 88 : side * fill;
  return (
    <div className={`tp-fit tp-fit--${format}`} ref={ref}>
      {side > 0 && <PrintFaceThumb day={day} format={format} edition={edition} width={Math.round(width)} />}
    </div>
  );
};

export default FitFace;
